

const { document } = require('window');

const $ = require('jquery');
require('bootstrap');

/*
 * Extended bootstrap tooltip
 * See `DEFAULTS` for comments on new options
 */

const Tooltip = $.fn.tooltip.Constructor;
const Plugin = $.fn.tooltip;

var ExtendedTooltip = function () {
	Tooltip.apply(this, arguments);
	this.constructor = ExtendedTooltip;
	return this;
};

ExtendedTooltip.DEFAULTS = {
	// makes tooltip not disappear if it's hovered
	// goes well with 'delay' option
	stayOnHover: false,

	// dismiss on any click outside of tooltip and it's trigger
	// use with `trigger: 'click'`
	dismissOnNextClick: false,

	// use `$(titleTemplate).html()` for tooltip title
	titleTemplate: null,

	// use `$(titleSelector)` itself for tooltip title
	titleSelector: null,

	// detach tip from document when it's hidden, disabled for knockout compatibility
	detachTip: false,

	// toggle custom classes on the template (e.g. { 'tooltip-custom': true })
	css: {},
};

ExtendedTooltip.prototype = $.extend({}, Tooltip.prototype, {
	init: function (type, element) {
		const ret = Tooltip.prototype.init.apply(this, arguments);

		const $element = $(element);
		if (/focus/.test(this.options.trigger)
			&& !$element.is('a')
			&& ($element.attr('tabindex') === undefined
				|| $element.attr('role') !== 'button')
		   ) {
			console.warn(
				"For proper cross-browser and cross-platform \"focus\" behavior, you must use"
					+ " the <a> tag, and you also must include the"
					+ " role=\"button\" and tabindex attributes",
				element
			);
		}

		if (this.options.stayOnHover) {
			if (!this.options.delay) { // add default hide delay
				this.options.delay = { hide: 500 };
			}

			this.tip().on('mouseleave.tooltip', $.proxy(this.leave, this));

			this.$element.on('hide.bs.tooltip', e => {
				// HACK: this check is necessary for data-dismiss="tooltip" to work
				if (this._ignoreStayOnHover) {
					return;
				}
				if (this.tip().is(':hover')) {
					e.preventDefault();
				}
			});
		}

		if (this.options.dismissOnNextClick) {
			$(document).on('click.bs.tooltip', e => {
				if (!this.isInStateTrue()) {
					return;
				}

				const $target = $(e.target);

				if ($target.closest(this.$element)[0]
					|| $target.closest(this.$tip)[0]) {
					return;
				}

				this.inState.click = false;
				this.hide();
			});
		}

		return ret;
	},
	tip: function () {
		const $tip = Tooltip.prototype.tip.apply(this, arguments);
		$.each(this.options.css, function (cls, enable) {
			$tip.toggleClass(cls, enable);
		});
		return $tip;
	},
	getOptions: function () {
		const opts = Tooltip.prototype.getOptions.apply(this, arguments);

		if (opts.titleTemplate) {
			opts.html = true;
			opts.title = function () {
				return $(opts.titleTemplate).html();
			};
		}

		return opts;
	},
	getTitle: function () {
		if (this.options.titleSelector) {
			return $(this.options.titleSelector);
		}
		return Tooltip.prototype.getTitle.apply(this, arguments);
	},
	setContent: function () {
		const $tip = this.tip();
		const title = this.getTitle();

		const inner = $tip.find('.tooltip-inner');

		if (this.options.titleSelector) {
			inner.append(title);
			title.show();
		} else {
			inner[this.options.html ? 'html' : 'text'](title);
		}
		$tip.removeClass('fade in top bottom left right');
	},
	show: function () {
		if (!this.options.detachTip) {
			this.tip().show();
		}
		return Tooltip.prototype.show.apply(this, arguments);
	},
	hide: function (callback) {
		const tipParentBackup = this.tip().parent();
		return Tooltip.prototype.hide.call(this, $.proxy(function () {
			if (!this.options.detachTip && this.$tip) {
				this.$tip
					.hide()
					.appendTo(tipParentBackup);
			}
			if (callback) {
				callback.apply(this, arguments);
			}
		}, this));
	},
	destroySync: function () {
		clearTimeout(this.timeout);
		this.$element.off('.' + this.type).removeData('bs.' + this.type);
		if (this.$tip) {
			this.$tip.detach();
		}
		this.$tip = null;
		this.$arrow = null;
		this.$viewport = null;
		this.$element = null;
	},
});

function ExtendedPlugin (option) {
	return this.each(function () {
		const $this = $(this);
		let data = $this.data('bs.tooltip');
		const options = typeof option == 'object' && option;

		if (!data && /destroy|destroySync|hide/.test(option)) {
			return;
		}
		if (!data) {
			$this.data('bs.tooltip', (data = new ExtendedTooltip(this, options)));
		}
		if (typeof option == 'string') {
			data[option]();
		}
	});
}

$.fn.tooltip = ExtendedPlugin;
$.fn.tooltip.Constructor = ExtendedTooltip;

$.fn.tooltip.noConflict = function () {
	$.fn.tooltip = Plugin;
	$.fn.tooltip.Constructor = Tooltip;
	return this;
};


$(document).on('click', '[data-dismiss="tooltip"]', function () {
	const tooltip = $(this).closest('.tooltip').data('bs.tooltip');
	if (!tooltip) {
		return;
	}
	tooltip._ignoreStayOnHover = true;
	tooltip.hide();
	tooltip._ignoreStayOnHover = false;
});

$(document).on('click', '[data-tooltip="trigger"]', function (e) {
	e.preventDefault();
	
	const $element = $(e.target);
	const $parent = $(e.currentTarget);
	const tooltipTemplate = $parent.next().find('[data-tooltip="template"]');

	$element.tooltip({
		titleTemplate: tooltipTemplate,
		trigger: 'click',
		dismissOnNextClick: true,
	});

	$parent.attr('data-tooltip', 'template-assigned');
	$element.trigger('click');
});

module.exports = $.fn.tooltip;

